import {
  Card,
  Popover,
  PopoverBody,
  Spinner,
  Table,
  Tooltip,
} from "reactstrap";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import styled from "styled-components";
import {
  ColorCodeInterface,
  RiskColorCode,
} from "utilFunctions/Constants/Constants";
import DownArrow from "Assets/Icons/downArrow30.png";
import UpArrow from "Assets/Icons/upArrow30.png";
import moment from "moment";
import {
  calculatePercentage,
  roundToAnyDecimalPlaces,
} from "utilFunctions/helperFunctions/utilFunctions";
import { capitalizeFirstCharaterOfString } from "utilFunctions/helperFunctions/utilFunctions";
import { useContext, useEffect, useState } from "react";
import "./index.css";
// import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { ToastContextDispatch } from "Context/CommonContext";
import {
  BASE_URL,
  GET_TESTSYLLABUS_STATUS,
} from "utilFunctions/Constants/urlConstants";
import { usePutPostAPI } from "utilFunctions/CustomHooks/usePutPostAPI";
import { displayNumberWithDecimals } from "Pages/BranchHealth/BranchHealthTable";
import { useNavigate } from "react-router-dom";
import InfoIcon from "Assets/Icons/InfoIcon";
const SORT_ASC = "ASC";
const SORT_DESC = "DESC";
const RiskStyledDiv = styled<any>("div")`
  background-color: ${(props: any) => props.color};
  border-radius: 4px;
  border: 1px solid
    ${(props: any) => (props.color == "#F5F5F5" ? "#757575" : props.color)};
  padding: 4px;
  width: fit-content;
  cursor: pointer;
`;
const RiskStyledDSpan = styled<any>("span")`
  color: ${(props: any) => props.color};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;
export const returnPlannedLecture = (val1: number, val2: number) => {
  return val1 + "/" + val2;
};
export const returnRiskSegment = (
  percentage: number,
  additionalContent: any,
  isPlannedLecture: boolean
) => {
  const segment: any =
    percentage === 100
      ? "Low"
      : percentage < 100 && percentage > 75
      ? "Moderate"
      : "High";
  const colorCode = RiskColorCode.find(
    (item: ColorCodeInterface) => item.name === segment
  );
  return (
    <RiskStyledDiv color={isPlannedLecture ? "#F5F5F5" : colorCode?.bgColor}>
      <RiskStyledDSpan color={isPlannedLecture ? "#757575" : colorCode?.color}>
        {additionalContent}
      </RiskStyledDSpan>
    </RiskStyledDiv>
  );
};
export const returnBatchData = (testSyllbStatus: any = [], id: number) => {
  return testSyllbStatus.filter((ele: any) => ele.batchId === id)?.[0]
    ?.testSyllabusStatusDataList;
};
export const popBodyShowComponent: any = (popoverContent: any) => {
  return (
    <>
      <div className="d-flex gap-2">
        {popoverContent?.map((ele: any) =>
          returnRiskSegment(
            roundToAnyDecimalPlaces(
              Number(
                displayNumberWithDecimals(
                  calculatePercentage(ele.markedNodeCount, ele.totalNodeCount)
                )
              ),
              2
            ),
            ele?.subject &&
              capitalizeFirstCharaterOfString(ele?.subject) +
                " : " +
                roundToAnyDecimalPlaces(
                  Number(
                    displayNumberWithDecimals(
                      calculatePercentage(
                        ele.markedNodeCount,
                        ele.totalNodeCount
                      )
                    )
                  ),
                  2
                ) +
                " %",
            false
          )
        )}
      </div>
    </>
  );
};
const SyllabusComplianceBatchTable = ({
  tableloading,
  tableHeading,
  tableData,
  sortColumn,
  setSortColumn,
  sortOrder,
  setSortOrder,
  testSyllbStatus,
  setTestSyllabusStatus,
}: any) => {
  const { screen }: any = useWindowSize();
  const navigate = useNavigate();
  const ToastDispatch = useContext(ToastContextDispatch);
  const [popoverOpen, setPopoverOpen] = useState<boolean>(false);
  const [popoverContent, setPopoverContent] = useState<any>([]);
  const [hoveredColumn, setHoveredColumn] = useState<string | null>(null);
  const [tooltipOpen2, setTooltipOpen2] = useState(false);
  const toggle2 = () => setTooltipOpen2(!tooltipOpen2);
  const { makeRequest: PostTestSyllabusStatus } = usePutPostAPI(
    (data: any) => {
      if (data["data"] && data["data"].length) {
        setTestSyllabusStatus(data["data"]);
      } else {
        setTestSyllabusStatus([]);
      }
    },
    (error) => {
      if (error && error["message"]) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    },
    "Post"
  );
  const togglePopover = (column: string, content: string) => {
    setHoveredColumn(column);
    setPopoverContent(content);
    setPopoverOpen(!popoverOpen);
  };

  const closePopover = () => {
    setHoveredColumn(null);
    setPopoverOpen(false);
  };
  const displayNumberWithDecimals = (number: any) => {
    if (Number.isInteger(number)) {
      return number.toString(); // Return the integer as a string
    } else {
      return number.toFixed(2); // Return the number with two decimals
    }
  };
  const renderingTime = (date: any) => {
    return <div className="d-flex">{moment(date).format("D MMM YY")}</div>;
  };

  const routeToMyBatch = (item: any) => {
    navigate("/admin/mybatch/" + item.id, {
      replace: false,
      state: {
        batch: item,
      },
    });
  };
  const routeToTest = (item: any) => {
    const testDetails = {
      type: item.testType,
      startDate: item.startDate,
      endDate: item.endDate,
    };
    navigate("/admin/mybatch/test/" + item.testId, {
      replace: false,
      state: {
        test: testDetails,
        batchId: item.id,
        testSyllabusStatus: testSyllbStatus,
        batchName: item.batchName,
      },
    });
  };
  const renderColumn = (
    item: any,
    value: any,
    columnValue: any,
    columnLabel: any,
    index: any
  ) => {
    switch (columnValue) {
      case "startDate":
        return (
          <td>
            <div className="d-flex">
              {renderingTime(item.startDate)}
              {"-"}
              {renderingTime(item.endDate)}{" "}
            </div>
          </td>
        );
      case "testDate":
        return <td> {item?.testDate ? renderingTime(item?.testDate) : "-"}</td>;
      case "format":
        return (
          <td>
            {item?.testType} |{item?.mode}
          </td>
        );
      case "batchName":
        return (
          <td>
            <span className="filterSpan" onClick={() => routeToMyBatch(item)}>
              {value}
            </span>
          </td>
        ); //
      case "testSyllbStatus":
        return (
          <td
            onClick={() =>
              returnBatchData(testSyllbStatus, item.id) &&
              togglePopover(
                "testSyllabusStatus" + index,
                returnBatchData(testSyllbStatus, item.id)
              )
            }
            onMouseLeave={closePopover}
            id={"testSyllabusStatus" + index}
          >
            {returnBatchData(testSyllbStatus, item.id)
              ? popBodyShowComponent(returnBatchData(testSyllbStatus, item.id))
              : "-"}
            <Popover
              placement="bottom"
              isOpen={
                hoveredColumn == "testSyllabusStatus" + index
                  ? popoverOpen
                  : false
              }
              target={"testSyllabusStatus" + index}
              toggle={closePopover}
            >
              <PopoverBody className="syllabusComplianceBatchPopover">
                <div className="plannedLectureHeading">
                  Total topics covered for the test
                </div>
                {popoverContent.map((ele: any, index: number) => (
                  <div
                    key={index}
                    className="d-flex justify-content-between mb-2"
                  >
                    {returnRiskSegment(
                      roundToAnyDecimalPlaces(
                        Number(
                          displayNumberWithDecimals(
                            calculatePercentage(
                              ele.markedNodeCount,
                              ele.totalNodeCount
                            )
                          )
                        ),
                        2
                      ),
                      ele?.subject,
                      false
                    )}
                    <div className="statusHeading">
                      {returnPlannedLecture(
                        ele.markedNodeCount,
                        ele.totalNodeCount
                      )}
                    </div>
                  </div>
                ))}
              </PopoverBody>
            </Popover>
          </td>
        );
      case "plLecStatus":
        return (
          <td
            onClick={() =>
              item?.plLecStatus &&
              togglePopover("plLecStatus" + index, item?.plLecStatus)
            }
            onMouseLeave={closePopover}
            id={"plLecStatus" + index}
          >
            <Popover
              placement="bottom"
              isOpen={
                hoveredColumn == "plLecStatus" + index ? popoverOpen : false
              }
              target={"plLecStatus" + index}
              toggle={closePopover}
            >
              <PopoverBody className="syllabusComplianceBatchPopover">
                <div className="plannedLectureHeading">
                  Planned lectures completed
                </div>
                {popoverContent.map((ele: any, index: number) => (
                  <div
                    key={index}
                    className="d-flex justify-content-between mb-2"
                  >
                    {returnRiskSegment(
                      roundToAnyDecimalPlaces(
                        Number(
                          displayNumberWithDecimals(
                            calculatePercentage(
                              ele.markedPlLecCount,
                              ele.totalPlLecCount
                            )
                          )
                        ),
                        2
                      ),
                      ele?.subj,
                      true
                    )}
                    <div className="statusHeading">
                      {returnPlannedLecture(
                        ele.markedPlLecCount,
                        ele.totalPlLecCount
                      )}
                    </div>
                  </div>
                ))}
              </PopoverBody>
            </Popover>
            <div className="d-flex gap-2">
              {item?.plLecStatus?.map((ele: any) =>
                returnRiskSegment(
                  roundToAnyDecimalPlaces(
                    Number(
                      displayNumberWithDecimals(
                        calculatePercentage(
                          ele.markedPlLecCount,
                          ele.totalPlLecCount
                        )
                      )
                    ),
                    2
                  ),
                  ele?.subj &&
                    capitalizeFirstCharaterOfString(ele?.subj) +
                      " : " +
                      returnPlannedLecture(
                        ele.markedPlLecCount,
                        ele.totalPlLecCount
                      ),
                  true
                )
              )}
            </div>
          </td>
        );
      case "testType":
        return (
          <td>
            <div className="d-flex flex-row gap-2 align-items-center">
              {item?.testType && item.testType === "No Upcoming Test" ? (
                <span>{"Not Scheduled"}</span>
              ) : (
                <span className="filterSpan" onClick={() => routeToTest(item)}>
                  {item?.testType}
                </span>
              )}
            </div>
          </td>
        );
      default:
        return <td>{value}</td>;
    }
  };
  const handleSort = (column: any) => {
    sortOrder === SORT_ASC ? setSortOrder(SORT_DESC) : setSortOrder(SORT_ASC);
    setSortColumn(column);
  };
  useEffect(() => {
    if (tableData && tableData.length > 0) {
      const url = BASE_URL + GET_TESTSYLLABUS_STATUS;
      const obj = (tableData || []).map((ele: any) => ({
        batchId: ele.id,
        testScheduleId: ele.testId,
      }));
      const filteredList = obj.filter((ele: any) => ele.testScheduleId != null);
      if (filteredList.length > 0) {
        PostTestSyllabusStatus(url, filteredList);
      }
    }
  }, [tableData]);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    document.body.classList.add("noOverflow");
    return () => {
      document.body.classList.remove("noOverflow");
    };
  }, []);
  return (
    <div
      className={
        !["xs", "sm", "md"].includes(screen)
          ? "syllabusComplianceBatchDiv pr-3"
          : "syllabusComplianceBatchDivMB"
      }
    >
      <Card className="mb-0 table-border-custom">
        <div className="tableFixHead">
          {!tableloading && tableData && tableData.length === 0 ? (
            <div className="mt-4 mb-8">
              <NoResultFoundSearch
                primaryMessage="Batch list not available."
                secondaryMessage={
                  "No batches allotted to the selected Branch and Stream. Try changing the filter or contact your EDP team for assistance."
                }
              >
                <NoDataFoundIcon />
              </NoResultFoundSearch>
            </div>
          ) : (
            <Table responsive className="table table-hover table-border-custom">
              <thead className="table-light-custom border-top table-border-custom">
                {tableHeading.map(
                  (column: { label: string; value: string }, index: number) => {
                    return (
                      <th
                        key={index}
                        onClick={() => {
                          if ([""].includes(column.value)) {
                            handleSort(column.value);
                          }
                        }}
                      >
                        {column.label}
                        {column.value === "testSyllbStatus" ? (
                          <span>
                            <InfoIcon id={"Tooltip-attendance3"}></InfoIcon>
                            <Tooltip
                              placement={"top"}
                              isOpen={tooltipOpen2}
                              target={"Tooltip-attendance3"}
                              toggle={toggle2}
                            >
                              {
                                "Indicates the topics covered in the subject for the upcoming test of the particular batch."
                              }
                            </Tooltip>
                          </span>
                        ) : null}
                        {[""].includes(column.value) ? (
                          <span className="cursor-pointer">
                            {sortColumn == column.value &&
                            sortOrder === SORT_ASC ? (
                              <img width={16} height={12} src={UpArrow} />
                            ) : (
                              <img width={16} height={12} src={DownArrow} />
                            )}
                          </span>
                        ) : null}
                      </th>
                    );
                  }
                )}
              </thead>
              <tbody>
                {tableloading ? (
                  <tr>
                    <td colSpan={6}>
                      <div className="d-flex justify-content-center">
                        <Spinner color="info" />
                      </div>
                    </td>
                  </tr>
                ) : (
                  !tableloading &&
                  tableData &&
                  Array.isArray(tableData) &&
                  tableData.map((TestsItem: any, index: any) => {
                    return (
                      <tr key={index}>
                        {tableHeading.map(
                          (column: { label: string; value: string }) => (
                            <>
                              {" "}
                              {renderColumn(
                                TestsItem,
                                TestsItem[column.value],
                                column.value,
                                column.label,
                                index
                              )}
                            </>
                          )
                        )}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          )}
        </div>
      </Card>
    </div>
  );
};

export default SyllabusComplianceBatchTable;
